import React, { useEffect, useRef } from 'react';
import { Link } from 'gatsby';

export const LogoContextMenu = ({ x, y, onDownloadSvg }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    // Adjust position if menu would go off screen
    if (menuRef.current) {
      const rect = menuRef.current.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      let adjustedX = x;
      let adjustedY = y;

      if (x + rect.width > windowWidth) {
        adjustedX = windowWidth - rect.width - 10;
      }

      if (y + rect.height > windowHeight) {
        adjustedY = windowHeight - rect.height - 10;
      }

      menuRef.current.style.left = `${adjustedX}px`;
      menuRef.current.style.top = `${adjustedY}px`;
    }
  }, [x, y]);

  const handleKeyDown = (e, callback) => {
    // Handle Enter or Space key presses
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      callback();
    }
  };

  return (
    <div
      ref={menuRef}
      className="fixed z-50 w-48 rounded-md border border-black/10 bg-white shadow-lg"
      style={{ left: `${x}px`, top: `${y}px` }}
      onClick={e => e.stopPropagation()}
      onKeyDown={e => e.stopPropagation()}
      role="menu"
      aria-label="Logo options"
      tabIndex={-1}
    >
      <Link
        to="/brand-guidelines/"
        className="flex cursor-pointer px-4 py-2 text-sm hover:bg-black/5"
        role="menuitem"
      >
        Brand Guidelines
      </Link>
      <button
        type="button"
        className="flex w-full cursor-pointer px-4 py-2 text-left text-sm hover:bg-black/5"
        onClick={onDownloadSvg}
        onKeyDown={e => handleKeyDown(e, onDownloadSvg)}
        role="menuitem"
      >
        Download SVG
      </button>
    </div>
  );
};
